// extracted by mini-css-extract-plugin
export default {"playBtn":"style_playBtn__Iz5QE","icon":"style_icon__JPeyK","bg_main":"style_bg_main__iYqR7","bg_top":"style_bg_top__jGpI4"};